import { render, staticRenderFns } from "./widget_alerts.vue?vue&type=template&id=8eb17482&scoped=true&"
import script from "./widget_alerts.vue?vue&type=script&lang=js&"
export * from "./widget_alerts.vue?vue&type=script&lang=js&"
import style0 from "./widget_alerts.vue?vue&type=style&index=0&id=8eb17482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb17482",
  null
  
)

export default component.exports